import { MenuItem, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { PET_GENDERS } from "../../features/pets/utils/Functions";

// Pet gender dropdown - MALE, FEMALE and UNKNOWN (shown as "Other")
export default function GenderSelect({ name = "gender", testId }) {
  const { control } = useFormContext();
  const { t } = useTranslation();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue="MALE"
      render={({ field }) => (
        <TextField
          {...field}
          value={field.value ?? "MALE"}
          select
          fullWidth
          label={t("Gender")}
          inputProps={testId ? { "data-testid": testId } : undefined}
        >
          {PET_GENDERS.map((gender) => (
            <MenuItem
              key={gender}
              value={gender}
              data-testid={testId ? `${testId}.option.${gender}` : undefined}
            >
              {t(gender)}
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  );
}
